import generateIcon from 'components/_particles/icon/icon';
import { t } from 'javascripts/utils/withTranslation';

class SelectClearable {
  constructor($select) {
    if ($select.dataset.clearableInitialized === 'true') return;

    this.$select = $select;

    // Wrap the select in a container div
    this.$wrapper = document.createElement('div');
    this.$wrapper.className = 'select__wrap';
    $select.parentNode.insertBefore(this.$wrapper, $select);
    this.$wrapper.appendChild($select);

    // Create the clear button
    this.$clearBtn = document.createElement('button');
    this.$clearBtn.type = 'button';
    this.$clearBtn.className = 'button select__clear';
    this.$clearBtn.setAttribute('aria-label', t('Eingabe löschen'));
    this.$clearBtn.appendChild(generateIcon({ icon: 'bw-cross-large-line' }));
    this.$wrapper.appendChild(this.$clearBtn);

    this.updateVisibility();
    this.$select.addEventListener('change', () => this.updateVisibility());
    this.$clearBtn.addEventListener('click', () => this.clear());

    this.$select.dataset.clearableInitialized = 'true';
  }

  updateVisibility() {
    this.$clearBtn.hidden = this.$select.value === '';
  }

  clear() {
    this.$select.value = '';
    this.$select.dispatchEvent(new Event('change', { bubbles: true }));
    this.updateVisibility();
    this.$select.focus();
  }
}

document
  .querySelectorAll('.js-select--clearable')
  .forEach(($el) => new SelectClearable($el));
